import { createAction } from "redux-actions";
import _values from "lodash/values";
import _get from "lodash/get";

import { MODAL_SCREEN_SHOW } from "./modal/actionTypes";

// ----------------------------------------------------------------------------------------------------------------------------
//  Actions
// ----------------------------------------------------------------------------------------------------------------------------
export const AJAX_SUCCESS = "ajax/AJAX_SUCCESS";
export const AJAX_ERROR = "ajax/AJAX_ERROR";
export const AJAX_PENDING = "ajax/AJAX_PENDING";
export const AJAX_LOADING = "ajax/AJAX_LOADING";

export const loadingAction = createAction(AJAX_LOADING);
export const ajaxPendingAction = createAction(AJAX_PENDING);
export const ajaxSuccessAction = createAction(AJAX_SUCCESS);
export const ajaxErrorAction = createAction(AJAX_ERROR);

// ----------------------------------------------------------------------------------------------------------------------------
//  Reducer
// ----------------------------------------------------------------------------------------------------------------------------
const initialState = {
  isFetching: [],
  pendingTitle: null,
  pendingMessage: null,
  error: null,
  message: null,
  success: null,
};

export default function ajax(state = initialState, action) {
  if (/_PENDING$/.test(action.type)) {
    return applyPromisePending(state, action);
  }

  if (/_FULFILLED$/.test(action.type)) {
    return applyFinished(state, action);
  }

  if (/_REJECTED$/.test(action.type)) {
    return applyFinished(state, action);
  }

  if (action.type === AJAX_SUCCESS) {
    return applySuccess(state, action);
  }

  if (action.type === AJAX_ERROR) {
    return applyAjaxError(state, action);
  }

  if (action.type === AJAX_LOADING) {
    return applyLoading(state, action);
  }

  if (action.type === MODAL_SCREEN_SHOW) {
    return applyShowScreen(state, action);
  }

  return state;
}

// ----------------------------------------------------------------------------------------------------------------------------
//  Action Reducers
// ----------------------------------------------------------------------------------------------------------------------------
function applyPromisePending(state, { type }) {
  const isFetching = [...state.isFetching];
  isFetching.push(type);

  return {
    ...state,
    isFetching,
  };
}
function applyLoading(state, { payload }) {
  if (payload === null) {
    return {
      ...state,
      pendingTitle: null,
      pendingMessage: null,
    };
  }

  const { title, message } = payload;

  return {
    ...state,
    pendingTitle: title,
    pendingMessage: message,
  };
}

function applyFinished(state) {
  const isFetching = [...state.isFetching];
  isFetching.pop();

  // FIXME: Hacky
  // When ajaxPendingAction() has been called alone, there is one left in array
  if (isFetching.length === 1 && isFetching[0] === AJAX_PENDING) {
    isFetching.pop();
  }

  return {
    ...state,
    isFetching,
  };
}

function applySuccess(state, action) {
  const message = _get(action, "payload.message");

  const isFetching = [...state.isFetching];
  isFetching.pop();

  return {
    ...state,
    isFetching,
    success: message,
  };
}

function applyAjaxError(state, action) {
  let error = _get(action, "payload.error");
  let message = _get(action, "payload.message");

  if (!error && !message) {
    // 422 Laravel error response
    const errors = _values(action.payload || {});

    if (errors && errors.length) {
      message = errors[0];

      if (Array.isArray(message)) {
        message = message.join(" ");
      }

      error = "bad_request";
    }
  }

  const isFetching = [...state.isFetching];
  isFetching.pop();

  return {
    ...state,
    isFetching,
    error,
    message,
  };
}

function applyShowScreen(state) {
  return {
    ...state,
    error: null,
    message: null,
    success: null,
  };
}
